import { changeColorScheme } from "./colorScheme";
import { GrenadeObject } from "./grenadeObject";
import { type Coord } from "./types";
import { setMousePositionFromCoord, waitForAnimationEnd } from "./utils";

export class SmokebombObject extends GrenadeObject {
  static override readonly IMAGE_SRC = "/assets/flashbang.png";

  override async detonateAt(coord: Coord) {
    const smokeOverlay = document.createElement("div");
    smokeOverlay.className = "smoke-overlay";
    setMousePositionFromCoord(smokeOverlay, coord);
    document.body.appendChild(smokeOverlay);

    await waitForAnimationEnd(smokeOverlay);

    changeColorScheme("dark");
    smokeOverlay.classList.add("smoke-fade");

    await waitForAnimationEnd(smokeOverlay);

    smokeOverlay.remove();
  }
}
